
import Vue from 'vue';
import MenuOrBottomSheet from '@/components/base/MenuOrBottomSheet.vue';
import _keys from 'lodash/keys';
import _union from 'lodash/union';
import ClipboardCopy from '@/components/ClipboardCopy.vue';

export default Vue.extend({
	name: 'AdminTeamStats',
	props: {
		team: { type: Object, required: true },
	},
	computed: {
		teamUsersCount () {
			const uniqueUserIds: string[] = _union(_keys(this.team.userIds || {}), _keys(this.team.adminIds || {}), _keys(this.team.creatorIds || {})); // adminIds and creatorIds are deprecated
			return uniqueUserIds.length;
		},
	},
	components: {
		ClipboardCopy,
		MenuOrBottomSheet,
	},
});
